import { IBaseCard } from "./base-card.interface";

export const cardRequestExcludedFields = [
    "hash",
    "assignedUser",
    "isLoaded",
    "isLoading",
    "isPlaceholderCard",
    "daysSinceInStep",
    "secondsSinceInStep",
    "searchableTerms",
    "id",
    "statusIds",
    "_ts",
    "usersDenied",
    "_attachments",
    "_etag",
    "_rid",
    "_self",
] as const;

export type CardUpdateRequest<T = IBaseCard> = T extends object ? Omit<T, (typeof cardRequestExcludedFields)[number]> : never;
